import { useEffect, useState } from "react";
import { subscribeBusy } from "@/lib/api";

export default function GlobalBusyBar() {
  const [busy, setBusy] = useState(false);
  useEffect(() => subscribeBusy((n) => setBusy(n > 0)), []);
  if (!busy) return null;
  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-0.5 overflow-hidden" data-testid="global-busy-bar">
      <div className="h-full w-1/3 bg-[#C2502F] animate-busy-slide" />
    </div>
  );
}
